module.exports = __webpack_public_path__ + "static/media/BannerDisplayHrefsExample@3x.db0a9f00bf61189413f114cb39e8b574.jpg";